import { Controller } from '@hotwired/stimulus'

// Allergen line-changeover gate (CMP-105c). The line last ran a product
// carrying allergens this one doesn't, so the cook is shown the swap protocol
// and must deliberately confirm the line was cleared before the Start button
// arms. A *soft* control — confirming is one tap, and the server logs the
// changeover on start either way — it just makes starting an allergen-reduced
// run on a dirty line a conscious act rather than a reflex.
export default class extends Controller {
  static targets = ['confirm', 'start']

  connect () {
    // The button ships enabled (so a failed JS load can't lock the cook out of
    // a soft control). We take over the moment we connect: disabled until the
    // line-cleared confirm is ticked.
    this.sync()
  }

  sync () {
    this.startTarget.disabled = !this.confirmTarget.checked
  }
}
